import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Alert, Col, Row } from 'react-bootstrap';
import apiCall from '../../../helpers/apiCall';

class UserProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: null,
            initialUser: props.user,
            ...props.user,
        };
    }

    // we don't need to send everything to the backend, just what's changed
    toUpdate = () => {
        let toReturn = {};

        for (const key of Object.keys(this.state.initialUser)) {
            if (this.state[key] !== this.state.initialUser[key]) {
                toReturn[key] = this.state[key];
            }
        }

        return toReturn;
    };

    handleFormSubmit = async (e) => {
        e.preventDefault();

        const payload = this.toUpdate(),
            message = {
                type: 'success',
                text: 'User updated',
            };

        if (!payload) {
            this.setState({
                message: {
                    type: 'success',
                    text: 'User updated',
                },
            });
        } else {
            const { success, message: responseMessage } = await apiCall(
                'PUT',
                '/users/' + this.state.initialUser._id,
                payload
            );

            message.text = responseMessage;

            if (!success) {
                message.type = 'warning';
            }
        }

        this.setState({
            message,
        });
    };

    handleInputChange = (e) => {
        const input = e.target;

        this.setState({
            [input.name]: input.value,
        });
    };

    render() {
        const { message } = this.state;
        return (
            <section id='user-profile'>
                <div
                    className={
                        'form form--two-cols' +
                        (message ? ' form--with-error' : '')
                    }>
                    {message && (
                        <Alert variant={message.type}>{message.text}</Alert>
                    )}
                    <div className='form__content'>
                        <form action='/' onSubmit={this.handleFormSubmit}>
                            <Row>
                                <Col>
                                    <div className='form__field'>
                                        <label htmlFor='firstName'>
                                            First name
                                        </label>
                                        <input
                                            type='text'
                                            name='firstName'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.firstName}
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='lastName'>
                                            Last name
                                        </label>
                                        <input
                                            type='text'
                                            name='lastName'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.lastName}
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='email'>Email</label>
                                        <input
                                            type='text'
                                            name='email'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.email}
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='phoneNumber'>
                                            Phone number
                                        </label>
                                        <input
                                            type='text'
                                            name='phoneNumber'
                                            onChange={this.handleInputChange}
                                            defaultValue={
                                                this.state.phoneNumber
                                            }
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='timeZone'>
                                            Time zone
                                        </label>
                                        <input
                                            type='text'
                                            name='timeZone'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.timezone}
                                        />
                                    </div>
                                </Col>
                                <Col>
                                    <div className='form__field'>
                                        <label htmlFor='addressLineOne'>
                                            Address line 1
                                        </label>
                                        <input
                                            type='text'
                                            name='addressLineOne'
                                            onChange={this.handleInputChange}
                                            defaultValue={
                                                this.state.addressLineOne
                                            }
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='addressLineTwo'>
                                            Address line 2
                                        </label>
                                        <input
                                            type='text'
                                            name='addressLineTwo'
                                            onChange={this.handleInputChange}
                                            defaultValue={
                                                this.state.addressLineTwo
                                            }
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='townCity'>
                                            Town / City
                                        </label>
                                        <input
                                            type='text'
                                            name='townCity'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.townCity}
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='state'>State</label>
                                        <input
                                            type='text'
                                            name='state'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.state}
                                        />
                                    </div>
                                    <div className='form__field'>
                                        <label htmlFor='zipCode'>zipCode</label>
                                        <input
                                            type='text'
                                            name='zipCode'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.zipCode}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div />
                                    <div className='form__field'>
                                        <label htmlFor='adminNotes'>
                                            Admin notes
                                        </label>
                                        <textarea
                                            name='adminNotes'
                                            onChange={this.handleInputChange}
                                            defaultValue={this.state.adminNotes}
                                            rows='6'
                                            style={{
                                                minHeight: '6rem',
                                            }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <div className='form__buttons'>
                                <button
                                    type='submit'
                                    className='btn btn--primary'>
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(UserProfile);
